module.exports = __webpack_public_path__ + "img/Path28522.6e232e74.png";